import { Button, Col, Input, message, Pagination, Row, Space } from "antd";
import { Link } from "react-router-dom";
import { ImageUrl } from "../../config/helper";
import { useNavigate } from "react-router-dom";

const BlogComponent1 = () => {
  const CustomBox = ({ image, headingBlog, heading, text , onClick}) => {
    return (
      <Col md={24}>
        <div className="blog-cards" onClick={onClick} style={{ cursor: "pointer" }}>
          <img src={image} alt="blog" className="rounded-lg mb-8" />
          <div>
            <h6 className="headingblog-yellow">{headingBlog}</h6>
            <h5 className="blogtitle">{heading}</h5>
            <p className="text-[#666666] text-[15px] antialiased py-2">
              {text} <br />
              {/* <Link
                to="/blogDetails"
                className="text-customGold hover:text-customGold"
              >
                READ MORE...
              </Link> */}
            </p>
          </div>
        </div>
      </Col>
    );
  };

  const items = [
    {
      image: ImageUrl("b-img-1.png"),
      headingBlog: "Blogs",
      heading:
        "Top 5 Reasons to Choose a Luxury Chauffeur Service Over Ride-Sharing Apps",
      text: "Ride-sharing is a quick and convenient solution for most travelers these days. Despite the many…",
      route: "/BlogDetails", 
    },
    {
      image: ImageUrl("b-img-2.png"),
      headingBlog: "Blogs",
      heading: "5 Benefits of Hiring a Professional Chauffeur for Your Event",
      text: "Any significant event, be it a wedding, corporate gathering, or a special celebration, depends on…",
      route: "/BlogDetails2", 
    },
    {
      image: ImageUrl("b-img-3.png"),
      headingBlog: "Blogs",
      heading: "Why Choose a Sprinter for Your Next Group Outing?",
      text: "Whether it is a family gathering, corporate event, or a friends' getaway, transportation is always…",
      route: "/BlogDetails3", 
    },
  ];
  const navigate = useNavigate();
  return (
    <Row justify="center">
      <Col xxl={18} md={20} sm={22} xs={23} className="py-16 border-b">
        <Row justify="center" gutter={[16, 48]}>
          <Col lg={17} md={24}>
            <Row justify="center" gutter={[16, 48]}>
              {items.map((item) => (
                <CustomBox
                  image={item.image}
                  headingBlog={item.headingBlog}
                  heading={item.heading}
                  text={item.text}
                  onClick={() => navigate(item.route)}
                />
              ))}
            </Row>
          </Col>
          <Col lg={7} md={24}>
            <div className="py-8">
              <Space
                direction="vertical"
                size="middle"
                style={{
                  width: "100%",
                }}
              >
                <Space.Compact
                  style={{
                    width: "100%",
                  }}
                >
                  <Input
                    defaultValue="search"
                    style={{ backgroundColor: "#323232", color: "#fff", border:"0" }}
                  />
                  <Button
                    type="primary"
                    style={{ backgroundColor: "#fef39b", color: "#000", height:"50px", borderRadius:"0" }}
                    className="web-btn"
                  >
                    Search
                  </Button>
                </Space.Compact>
              </Space>
            </div>
            <div className="py-8">
              <h4 className="blogtitle">Recent Posts</h4>
              <h6 className="text-[#666666] text-[15px] antialiased py-2">
                Top 5 Reasons to Choose a Luxury Chauffeur Service Over
                Ride-Sharing Apps
              </h6>
              <h6 className="text-[#666666] text-[15px] antialiased py-2">
                5 Benefits of Hiring a Professional Chauffeur for Your Event
              </h6>
              <h6 className="text-[#666666] text-[15px] antialiased py-2">
                Why Choose a Sprinter for Your Next Group Outing?
              </h6>
            </div>
            <div className="py-8">
              <h4 className="blogtitle">Recent Comments</h4>
              <h6 className="text-[#666666] text-[15px] antialiased py-2">
                No comments to show.
              </h6>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default BlogComponent1;
